import { useMutation } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { ApiError } from "src/types/interfaces/api-error";
import { OrganizationOnboardingPayload } from "src/types/payloads/onboarding-payload";
import { organizationDetailsApi } from "../../api/lib/organization-details";

export const useCompleteOrganizationRegistration = (onSuccess?: () => void) => {
  return useMutation({
    mutationFn: (values: OrganizationOnboardingPayload) =>
      organizationDetailsApi.completeRegistration(values),
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
